const WebConstant = {
    AC_MAX_TRY_TIME: "epl.ac_max_try_time",
    AC_TYP_AUTH_CSR: "authenticatecsr",
    AC_TYP_AUTH_USER: "authenticateUser",
    AC_TYP_CONFIRMATION: "confirmation",
    AC_TYP_REDIRECT_OR_SIGN_IN: "redirectOrSignIn",
    AC_TYP_REST_PW: "resetPassword",
    AC_TYP_SIGN_UP: "signUp",
    AC_TYP_SUCCESS: "successPage",
    AC_TYP_TMP_EMAIL: "sendEmail",
    AC_TYP_TMP_PW: "verifyTempPassword",
    AC_TYP_VERIFY_EM_N_SND_UN: "verifyEmailAndSendUN",
    AC_TYP_VERIFY_SQ_FPW: "verifySQAnswer",
    AC_TYP_VERIFY_UN_EM_FPW: "verifyUserNameEmail",
    AUDIT_MIGRATION_FLOW_SKIPPED: 314,
    AWS_REGION: "aws.region",
    CHK_HDR_NO_APPID: "noAppId",
    CHK_HDR_NO_DURL: "noDURL",
    COM_DOMAIN: ".collegeboard.com",
    CSR_COOKIE_NAME: "cbCsrLogin",
    CSR_DEFAULT_APPID: "116",
    CSR_DEFALUTDURL: "CSR_DEFALUTDURL",
    CSR_DURL: "CSR_URL",
    CSR_IDP: "CSR",
    CSR_SSO_APP_ID: "csr_appId",
    DEFAULT_LOGOUT_URL: "defaultLogoutURL",
    DEFALUTAPPID: "DEFALUTAPPID",
    DEFALUTDURL: "DEFALUTDURL",
    DESTINATION_PAGE: "destinationpage",
    DURL: "DURL",
    ECL_IDP: "ECL",
    EMIAL_TMPLATE_NAME_FUN: "ET_IAM_ForgotUserName_Prof",
    EMIAL_TMPLATE_NAME_LOCK: "ET_IAM_Lock_Prof",
    EMIAL_TMPLATE_NAME_RESET: "ET_IAM_Prof_Change_Password",
    EPL_AUTHENTICATED_USER_URL: "authenticatedUser.url",
    EPL_CREAT_CONF_URL: "EPL.createConfPage.url",
    EPL_DASHBOARD_URL: "EPL.dashboard.url",
    EPL_ENROLL_URL: "EPL.enroll.url",
    EPL_IDP: "EPL",
    EPL_LOGIN_URL: "EPL.signin.url",
    EPL_REQUEST_ACCESS_URL: "EPL.requestAccessPage.url",
    EPL_SHOW_ADD_ENROLL_URL: "EPL.showAddEnrollment.url",
    ET_FORGOT_PASSWORD: "ET_IAM_Prof_Temp_Password",
    FAILED_LOGIN_ATTEMPTS_COUNT: "failedLoginAttemptsCount",
    FLOW: "flow",
    FROM_ACTION: "pfIdp",
    FORM_NAME_CONFIRMAION: "confirmationForm",
    FORM_NAME_FUN_PAGE_LOAD: "forgotUsernameForm",
    FORM_NAME_FPWD_PAGE_LOAD: "forgotPasswordForm",
    FORM_NAME_LOGIN: "loginForm",
    FORM_NAME_SIGNUP_CHECK: "checkSignUpForm",
    FORM_NAME_TMP_LOGIN: "tempLoginForm",
    FORCEDLBA: "force_lba",
    FORCEDLBASESSSION: "FORCEDLBASESSSION",
    FROM_CREATE: "FROM_CREATE",
    FROM_PAGE: "FROM_PAGE",
    IAM_APP_ID: "8",
    IDP: "IdP",
    IDP_MISMATCH: "IdpMismatch",
    IDP_POST_ECL: "_stu",
    IDP_POST_UNI: "_uni",
    IS_VERIFY: "reqVerify",
    LOGINASAPPID: "LOGINASAPPID",
    LOGIN_MAX_TRY_TIME: "epl.login_max_try_time",
    LOGOUT_URL: "logout.url",
    MIGRATION_CONTROL_VALVE_VALUE: "CBIAM.MIGRATION.FLOOD_CONTROL_VALVE",
    NEED_CHECK_MIGRATION: "need.to.check.migration",
    NOENROLLCHECK: "NOENROLLCHECK",
    NONCE: "nonce",
    ORG_DOMAIN: ".collegeboard.org",
    PAGE_TITLE_LOGIN: "Sign-in",
    PAGE_TITLE_SIGNUP_CHECK: "Signup-Check",
    PAGE_TITLE_TMP: "Temp Password",
    PAGE_TITTLE_FUN_CONF: "Forgot Username: Confirmation Page",
    PAGE_TITTLE_FUN_LOAD: "Forgot Username",
    PASSWORD: "password",
    SECRETANSWER: "SECRETANSWER",
    SECRETQUESTION: "SECRETQUESTION",
    SERVICE_REGISTRY_PASSWORD: "service.registry.palogincloud.password",
    SERVICE_REGISTRY_USERNAME: "service.registry.palogincloud.username",
    SESSION_EXPIRED: "sessionExpired",
    SESSION_FROM_ACTION: "from_Action",
    SESSION_IDP: "SESSION_IDP",
    SIGN_ON_POLICY: "policy",
    SKIPENROLL: "skipEnroll",
    PRG_CODE: "prgCode",
    SSO_APP_ID: "appId",
    SSO_APPLICATION_ID: "applicationId",
    SSO_IDP: "idp",
    STUDENT_NAMESPACE: "st",
    TST: "tst",
    USE_SED_WIDGET: "CBIAM.LOGIN.USE_SED_WIDGET",
    USERNAME: "username",
    WEB_SESSION: "web_session",

    defaultAppId: 466,
    defaultDurl: "https://www.collegeboard.org/",
    defaultStdAppId: "466",
    defaultStdDurl: "https://www.collegeboard.org/",
    defaultProfAppId: 120,
    defaultProfDurl: "https://cbaccount.collegeboard.org/professional/dashboard",
    defaultCsrAppId: 116,
    defaultCsrDurl: "https://cat.collegeboard.org/cat/home.do",
    defaultLoginURL: "https://connect.collegeboard.org",
    defaultStdLoginURL: "https://connect.collegeboard.org",
    defaultProfLoginURL: "https://connect.collegeboard.org",
    defaultSignUpURL: "https://cbaccount.collegeboard.org/iamweb/smartRegister",
    defaultStdSignUpUrl:
        "https://cbaccount.collegeboard.org/iamweb/smartRegister",
    defaultProfSignUpUrl:
        "https://cbaccount.collegeboard.org/professional/smartRegister",
    defaultLogoutURL: "https://www.collegeboard.org/",
    cbLowerEnvCookieName: "lower_Env",
    cbTreeEnvCookieName: "cb_tree_env",
    cbLoginCookieName: "cb_login",
    SignOnPolicyEnumValues: {
        DEFAULT: "DEFAULT",
        VERIFY: "VERIFY",
        MFA1: "MFA1", // per session
        MFA2: "MFA2",
        CSR: "CSR",
    },
};

export default WebConstant;
